module.exports = __webpack_public_path__ + "img/icon_cipiao.eeb6e872.png";